var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransactionTransfer = function SvgIconTransactionTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M15.525 10.05a.625.625 0 0 1 0 .884l-4.174 4.183a.625.625 0 0 1-.885-.883l4.175-4.183a.625.625 0 0 1 .884-.001",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M.291 10.492c0-.345.28-.625.625-.625h14.167a.625.625 0 1 1 0 1.25H.916a.625.625 0 0 1-.625-.625M5.533.886a.625.625 0 0 1 0 .884L1.358 5.953a.625.625 0 1 1-.884-.883L4.649.887a.625.625 0 0 1 .884-.001",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M.291 5.508c0-.345.28-.625.625-.625h14.167a.625.625 0 1 1 0 1.25H.916a.625.625 0 0 1-.625-.625",
    clipRule: "evenodd"
  })));
};
export default SvgIconTransactionTransfer;